import {NgModule} from "@angular/core";
import {BrukerOppdaterAvatarOgNavnKomponentAvhengigheter} from "./komponenter/bruker-oppdater-avatar-og-navn/bruker-oppdater-avatar-og-navn";

@NgModule({
    providers: [
        BrukerOppdaterAvatarOgNavnKomponentAvhengigheter
    ]
})
export class BrukerModul{

}
